import axios from "axios";

const {
  REACT_APP_MAIN_PROJECT_API,
  REACT_APP_DEFAULT_API_BASE,
  REACT_APP_ROUTES_API_BASE,
  REACT_APP_SECTIONS_API_BASE,
  REACT_APP_SHIFT_MANAGERS_API_BASE,
} = process.env;

const buildApi = (url) =>
  axios.create({
    baseURL: url,
    withCredentials: true,
    transformResponse: axios.defaults.transformResponse.concat(
      (params) => params.data || params
    ),
  });

export const apis = {
  auth: buildApi(REACT_APP_MAIN_PROJECT_API),
  default: buildApi(REACT_APP_DEFAULT_API_BASE),
  routes: buildApi(REACT_APP_ROUTES_API_BASE),
  sections: buildApi(REACT_APP_SECTIONS_API_BASE),
  shiftManagers: buildApi(REACT_APP_SHIFT_MANAGERS_API_BASE),
};

const getApi = (service) => apis[service] || apis.default;

const getHeaders = (headers) => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  ...headers,
});

const api = {
  get: async ({ url, service = null }, headers) => {
    try {
      return await getApi(service).get(url, {
        headers: getHeaders(headers),
      });
    } catch (error) {
      if (error.response?.data?.message && error.response.data.statusCode) {
        error.message = error.response.data.message;
        error.statusCode = error.response.data.statusCode;
      }
      throw error;
    }
  },

  post: async ({ url, service = null }, headers, body = null) => {
    try {
      return await getApi(service).post(url, body, {
        headers: getHeaders(headers),
      });
    } catch (error) {
      if (error.response?.data?.message && error.response.data.statusCode) {
        error.message = error.response.data.message;
        error.statusCode = error.response.data.statusCode;
      }
      throw error;
    }
  },

  put: async ({ url, service = null }, headers, body = null) => {
    try {
      return await getApi(service).put(url, body, {
        headers: getHeaders(headers),
      });
    } catch (error) {
      if (error.response?.data?.message && error.response.data.statusCode) {
        error.message = error.response.data.message;
        error.statusCode = error.response.data.statusCode;
      }
      throw error;
    }
  },

  delete: async ({ url, service = null }, headers, body = null) => {
    try {
      return await getApi(service).delete(url, body, {
        headers: getHeaders(headers),
      });
    } catch (error) {
      if (error.response?.data?.message && error.response.data.statusCode) {
        error.message = error.response.data.message;
        error.statusCode = error.response.data.statusCode;
      }
      throw error;
    }
  },
};

export default api;
